import React, { useState, useEffect } from 'react';
import CourseCard from './courseCard';
import Empty from './empty';
import Modal from 'ac-components/modal';
import styles from './styles.scss';
import classnames from 'classnames';
import { getPackages, IPackageData, preOrder, IPreOrderData, IEchoData, createOrder, getCourses, ICoursesData } from '@services/my-home'; 
import moment from 'moment';
import { useTranslation } from 'hooks/use-translation';
import { history } from '@store/history';
import generatePath from '@utils/generatePath';
import { PERSONAL } from 'constants/url';
import { toast } from 'components/dialogs';
import Alert from 'ac-components/alert';

/**
 * 课程页面
 */
export default function CoursesView() {
	const { transData } = useTranslation('perfilAndAjustes');
	const [isShow, setShow] = useState(false);
	const [isSuccess, setSuccess] = useState(false);
	const [tipMessage, setTipMessage] = useState();

	const [pendingList, setPendingList] = useState<ICoursesData[]>([]); // 待完成课程
	const [finishList, setFinishList] = useState<ICoursesData[]>([]); // 已完成课程
	const [packageList, setPackageList] = useState<IPackageData[]>([]); // 课时包
	const [orderData, setOrderData] = useState<IPreOrderData[]>([]); // 课时包
	const [echoData, setEchoData] = useState<IEchoData[]>([]); // 回显数据
	const [isEmpty, setIsEmpty] = useState(false); // 空状态
	const [isMore, setIsMore] = useState(false); // 待完成课程 是否超过四节
	const monthData = transData.monthData;

	const getList = async (lessonState: number) => {
		//lessonState:  0 待上课 1 已上课
		return await getCourses({ pageNo: 1, pageSize: 99999, lessonState });
	};
	const getPackageList = async () => {
		return await getPackages({ pageNo: 1, pageSize: 99});
	};
	const getPreOrder = async (productDTOList: any) => {
		return await preOrder({ productDTOList});
	};
	const getCreateOrder = async (amount: string, productDTOList: any) => {
		return await createOrder({amount, productDTOList});
	};

	useEffect(() => {
		// 待上课
		getList(0).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				const list = data?.lessonCardList || [];
				setIsMore(list.length > 4);
				setPendingList(list);
			} else {
				setIsMore(false);
				setPendingList([]);
			}
		});
	}, []);

	useEffect(() => {
		// 已上课
		getList(1).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				const list = data?.lessonCardList || [];
				let dateStr = '';
				list.forEach((item: ICoursesData) => {
					const currentDateStr = moment(item.lessonStartTime).format('YYYY-MM');
					if (dateStr !== currentDateStr) {
						dateStr = currentDateStr;
						const strList = currentDateStr.split('-');
						item['customDateStr'] = `${monthData[strList[1] as keyof typeof monthData]} , ${strList[0]}`;
					}
				});
				setFinishList(list);
			} else {
				setFinishList([]);
			}
		});
	}, []);
	// 获取课时包
	useEffect(() => {
		getPackageList().then((res: any) => {
			const { code, data } = res;
			if (code === '0' && data.length > 0) {
				setPackageList(data);
			} else {
				setPackageList([]);
			}
		});
	}, []);
	// 预创建订单

	useEffect(() => {
		if (pendingList.length && finishList.length) {
			setIsEmpty(false);
		} else {
			setIsEmpty(false);
		}
	}, [pendingList, finishList]);
	const isEmptyList = (list: unknown[]) => {
		return list.length === 0;
	};
	const onClickMore = () => {
		setIsMore(false);
	};
	function buyButton(item: any) {
		setEchoData(item);
		const productDTOList = [{productId: "", realQuantity: "", standardQuantity: ""}];
		productDTOList[0].productId = item.id;
		productDTOList[0].realQuantity = item.classes;
		productDTOList[0].standardQuantity = item.classes;
		getPreOrder(productDTOList).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				setShow(!isShow);
				if (data.msg) setTipMessage(data.msg);
				setOrderData(data);
			} else {
				toast({ message: 'The order was not created successfully, please try again later'});
			}
		});
	}
	function closeBtn() {
		setShow(false);
	}
	function confirmBtn(data: any, data2: any) {
		const amount = data2.paidAmount;
		const productDTOList = [{productId: "",goodsAmount: "", realQuantity: "", standardQuantity: ""}];
		productDTOList[0].productId = data.id;  
		productDTOList[0].goodsAmount = data2.paidAmount;
		productDTOList[0].realQuantity = data.classes;
		productDTOList[0].standardQuantity = data.classes;
		getCreateOrder(amount,productDTOList).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				setShow(!isShow);
				setSuccess(true);
			}
		});
	}
	function successBtn() {
		setSuccess(false);
	}
	function jumpBuyLinks() {
		history.replace(generatePath(PERSONAL, { activeId: 3 }));
	}
	return (
		<div className={styles.ac_course_warp}>
			{isEmpty && <Empty />}
			{!isEmpty && (
				<>
				{/* 三个课程同时为空态 */}
				{isEmptyList(packageList) && isEmptyList(pendingList) && isEmptyList(finishList) && <Empty />}
					{!isEmptyList(packageList) && <div className={styles.package_warp}>
						<h3 className={styles.title}>{transData.classPackage}</h3>
						<div className={`${styles.packageList}`}>
						{packageList.map((item, index) => (
							<div className={styles.list} key={index}>
								<h4 className={styles.courseTitle}>{item.packageName}</h4>
								<div className={styles.tags}>
									{item.payType && <a>{item.payType}</a>}
									{item.courseLevel && <a title={item.courseLevel}>{item.courseLevel}</a>}
									{item.grades && <a title={item.grades}>{item.grades.join(', ')}</a>}
								</div>
								<p className={styles.time}><span></span>{item.classes} Sessions ({item.hours}h)</p>
								<div className={styles.operate}>
									<div className={styles.left}>
										<h2 className={styles.presentPrice}>{item.currCharacter}{item.price}</h2>
										<p className={styles.originalPrice}>{item.currCharacter}{item.originPrice}</p>
									</div>
									<button className={styles.buyBtn} onClick={(e: any) => { buyButton(item)}}>Buy</button>
								</div>
							</div>
						))}
						</div>
					</div>}
					
					{/* 两个课程为空态 */}
					{!isEmptyList(packageList) && isEmptyList(pendingList) && (
						<>
							<div className={styles.title_warp}>
								<h3 className={styles.title}>{transData.pendingCourses}</h3>
								{isMore && (
									<span className={styles.right_more} onClick={onClickMore}>
										{transData.more}
									</span>
								)}
							</div>
							<Empty />
						</>
					)}
					{!isEmptyList(pendingList) && (
						<>
						<div className={styles.title_warp}>
							<h3 className={styles.title}>{transData.pendingCourses}</h3>
							{isMore && (
								<span className={styles.right_more} onClick={onClickMore}>
									{transData.more}
								</span>
							)}
						</div>
						<div className={styles.card_content}>
							<div className={styles.card_box}>
								{isMore &&
									pendingList.slice(0, 4).map((item, i) => (
										<div className={styles.card_item_box} key={i}>
											<CourseCard {...item} />
										</div>
									))}

								{!isMore &&
									pendingList.map((item, i) => (
										<div className={styles.card_item_box} key={i}>
											<CourseCard {...item} />
										</div>
									))}
							</div>
						</div>
						</>
					)}
					{isMore && (
						<div className={styles.more_warp}>
							<span onClick={onClickMore}>{transData.more}</span>
						</div>
					)}

					{/* 已完成课程 */}
					{!isEmptyList(finishList) && (
						<>
							<div className={styles.title_warp}>
								<h3 className={styles.title}>{transData.coursesFinished}</h3>
							</div>
							<div className={`${styles.finish_box} ${styles.card_content} ${styles.card_box}`}>
								{finishList.map((item, i) => (
									<div className={`${styles.card_item_box} ${i % 2 !== 0 && item.customDateStr ? styles.block : ''}`} key={i}>
										{item.customDateStr && <h6 className={styles.subhead}>{item.customDateStr}</h6>}
										<CourseCard {...item} />
									</div>
								))}
							</div>
						</>
					)}
					
					<Modal onClose={closeBtn} show={isShow} className={classnames(styles['ac-modal'], 'ac-modal3')}>
						<div className={styles['ac-modal-wrap']}>
							<div className={styles['ac-modal-title']}>Preview Order</div>
							<div className={styles['ac-modal-tips']}>
								<p className={styles['tips-text']}><i className={styles['tips']}></i>Please contact the course consultant before placing an order.<br />{tipMessage}</p>
								<p className={styles['tips-text2']}><i className={styles['tips']}></i>Please contact the course consultant before<br /> placing an order.<br />{tipMessage}</p>
							</div>
							<div className={styles.course}>
								<h2 className={styles.title}>Course Information</h2>
								<div className={styles.information}>
									<h4 className={styles.tit}>{echoData.packageName}</h4>
									<div className={styles.tips}>
										{echoData.payType && <a>{echoData.payType}</a>}
										{echoData.courseLevel && <a>{echoData.courseLevel}</a>}
										{echoData.grades && <a title={echoData.grades}>{echoData.grades.join(', ')}</a>}
									</div>
									<div className={styles.time}><span></span>{echoData.classes} Sessions ({echoData.hours}h) </div>
								</div>
							</div>
							<div className={styles.discount}>
								<div className={styles.inline}>
									<span className={styles.left_content}>Discount Amount</span>
									<span className={styles.right_price}>-{echoData.currCharacter}{orderData.discountAmount}</span>
								</div>
								<div className={styles.inline}>
									<span className={styles.left_content}>Free Session</span>
									<span className={styles.right_price}>{orderData.freeSession} Session</span>
								</div>
								<div className={styles.inline}>
									<span className={styles.left_content}>Amount Payable</span>
									<span className={styles.present_price}>{echoData.currCharacter}{orderData.paidAmount}</span>
								</div>
							</div>
							<div className={styles['ac-modal-footer']}>
								<button className={styles.cancelBtn} onClick={closeBtn}>Cancel</button>
								<button className={styles.confirmBtn} onClick={()=> {confirmBtn(echoData, orderData)}}>Confirm</button>
							</div>
						</div>
					</Modal>
					<Modal onClose={successBtn} show={isSuccess} className={classnames(styles['ac-modal'], 'ac-modal4')}>
						<div className={styles['ac-modal-wrap']}>
							<div className={styles['ac-modal-title']}>Create Order</div>
							<div className={styles['ac-modal-body']}>
								<i className={styles.successTip}></i>
								<p className={styles.infoText}>Order successfully！<br />Please pay as soon as possible.</p>
							</div>
							<div className={styles['ac-footer']}>
								<button className={styles['payBtn']} onClick={ jumpBuyLinks }>Pay Now</button>
							</div>
						</div>
					</Modal>
				</>
			)}
		</div>
	);
}
